import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./Style.css";
import AboutImg from '../assets/About.jpeg';

function About() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/about-us");
  };

  return (
    <section className="about-container" id="About_Us">
      <div className="about-content">
        {/* Left: Image */}
        <div className="about-image">
          <img src={AboutImg} alt="Our Team" />
        </div>

        {/* Right: Text + Button */}
        <div className="about-text">
          <h2>About Us</h2>
          <p>
            TNG Global is a global travel company, dedicated to crafting unforgettable journeys that combine seamless planning, expert service, and unique experiences. With headquarters in USA and expanding operations worldwide, we specialize in <b>Flights, Holidays, Hotels, Car Hire, Cruise Voyages, Adventure Getaways,</b> and <b>Tailor-Made Travel Packages.</b>
          </p>
          <p>
            Established with a vision to redefine modern travel, TNG Global has quickly become one of the fastest-growing independent travel providers, trusted by thousands of travelers around the world.
          </p>
          <p>
            At TNG Global, every traveler is assigned a dedicated travel expert, whose priority is to understand your travel needs, preferences, and budget, and provide you with the best solutions. Our team is highly skilled, professional, and passionate about making sure your requests are handled with care, precision, and efficiency.
          </p>

          {/* <Button
            variant="contained"
            className="contact-button"
            onClick={() => navigate("/about-us")}
          >
            Discover Now
          </Button> */}

          {/* <Button
            variant="contained"
            className="about-button"
            onClick={handleNavigate}
            sx={{
              mt: 2,
              backgroundColor: "var(--primary-color)",
              fontWeight: "bold",
              padding: "10px 24px",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "var(--secondary-color)",
                color: "var(--primary-color)",
              },
            }}
          >
            Discover More
          </Button> */}
        </div>
      </div>
    </section>
  );
}

export default About;
